export class TrainingConstants {
  static TRAINING_CATALOGS = 1;
  static TRAINING_OVERVIEW = 2;
  static TRAINING_SESSION_INFORMATION = 3;
  static TRAINING_CONTACT_INFORMATION = 4
  static TRAINING_ADDITIONAL_INFORMATION = 5;
  static TRAINING_REVIEW = 6;
  static TRAINING_REQUEST_SUCCESS = 7
}
